export default __webpack_public_path__ + "static/media/decentraland.7140af41.svg";